import { render, staticRenderFns } from "./EmployeePaystub.vue?vue&type=template&id=67fac3a8&scoped=true&"
import script from "./EmployeePaystub.vue?vue&type=script&lang=ts&"
export * from "./EmployeePaystub.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeePaystub.vue?vue&type=style&index=0&id=67fac3a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fac3a8",
  null
  
)

export default component.exports